module.exports = __webpack_public_path__ + "static/media/user-plus.c7f45bb0.svg";